import React, { useCallback, useState } from "react";

import { v4 as uuidv4 } from "uuid";

import { useExtendedAnalytics } from "@app/util/analytic/AnalyticsService";
import AnalyticsContext from "@app/util/contexts/AnalyticsContext";

import CreateEmailModal from "./CreateEmailModal";
import CreateEmailModalsContext, {
  EmailsCreationModalsContextValue,
} from "./CreateEmailModalsContext";
import EmailCreationProvider from "./CreateEmailProvider";

const CreateEmailModalsProvider: React.FC = ({ children }) => {
  const emailCreationAnalytics = useExtendedAnalytics(["Bulk Email Modal"]);

  const [emailModals, setEmailModals] = useState<EmailsCreationModalsContextValue["emailModals"]>(
    []
  );

  const showEmailModal: EmailsCreationModalsContextValue["showEmailModal"] = useCallback(
    (params) => {
      const id = uuidv4();
      setEmailModals((emails) => [
        ...emails,
        {
          id,
          params,
        },
      ]);
      return id;
    },
    []
  );

  const hideEmailModal: EmailsCreationModalsContextValue["hideEmailModal"] = useCallback((id) => {
    setEmailModals((emails) => emails.filter((email) => email.id !== id));
  }, []);

  return (
    <CreateEmailModalsContext.Provider value={{ emailModals, hideEmailModal, showEmailModal }}>
      {children}
      {emailModals.map(({ id, params }) => (
        <EmailCreationProvider initialValues={params} key={id}>
          <AnalyticsContext.Provider value={emailCreationAnalytics}>
            <CreateEmailModal onHide={() => hideEmailModal(id)} />
          </AnalyticsContext.Provider>
        </EmailCreationProvider>
      ))}
    </CreateEmailModalsContext.Provider>
  );
};

export default CreateEmailModalsProvider;
